import AppCard from '@crema/core/AppCard';
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  InputLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Rating,
  Select,
  Stack,
  TablePagination,
  Typography,
  styled,
} from '@mui/material';
import {DataGrid} from '@mui/x-data-grid';
import {alpha} from '@mui/material';
import {red, green, grey} from '@mui/material/colors';

import React, {useCallback, useEffect, useState} from 'react';
import {ButtonOutlined} from 'shared/components/Button';
import {
  Add,
  DeleteOutline,
  EditOutlined,
  Filter,
  FilterAlt,
  FilterList,
  Visibility,
} from '@mui/icons-material';
import {useDispatch} from 'react-redux';
import {
  onDeleteAksiPerubahan,
  onGetListAksiPerubahan,
} from 'redux/actions/AksiPerubahan';
import {useSelector} from 'react-redux';
import AppSearch from '@crema/core/AppSearchBar';
import DialogPerubahan from './Dialog';
import DialogDelete from './Dialog/DialogDelete';
import DialogImport from './Dialog/DialogImport';
import AppInfoView from '@crema/core/AppInfoView';
import {onGetTitleOptions} from 'redux/actions/admintools/Title';
import {COLORS} from 'shared/constants/AppEnums';
import {makeStyles} from '@mui/styles';
import {MdFilterList} from 'react-icons/md';
import NestedMenu from './Dialog/NestedMenu';
import DialogFilter from './Dialog/DialogFilter';
import convertToRoman from 'shared/utils/convertToRoman';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiDataGrid-cell': {
      borderRight: '1px solid #e0e0e0', // Add right border to each cell
    },
  },
}));

export const AksiPerubahan = () => {
  const dispatch = useDispatch();
  const {dataAksiPerubahan} = useSelector((state) => state.aksiPerubahan);
  const {profileMe} = useSelector((state) => state.profile);

  const [openDialog, setOpenDialog] = useState(false);
  const [deletedId, setDeletedId] = useState([]);
  const [page, setPage] = useState(0);
  const [searchState, setSearchState] = useState('');
  const [isCrud, setIsCrud] = useState(false);
  const [title, setTitle] = useState(null);
  const [titleOptions, setTitleOptions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElAdd, setAnchorElAdd] = useState(null);

  const [pengawasBatch, setpengawasBatch] = useState([]);

  const handleClick = (event) => {
    setAnchorElAdd(event.currentTarget);
  };

  const handleClose = (params) => {
    // setTitle(params.target.id);
    setAnchorEl(null);
    setAnchorElAdd(null);
  };
  const {filter} = useSelector((state) => state.aksiPerubahan);

  const {optionsTitle} = useSelector((state) => state.jabatan);
  const [openOpenImportDialog, setOpenImportDialog] = useState(false);
  const [dialogFilter, setDialogFilter] = useState(false);

  const [openOpenDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [roleDialog, setRoleDialog] = useState('detail');
  const classes = useStyles();

  useEffect(() => {
    dispatch(onGetListAksiPerubahan());
    dispatch(onGetTitleOptions());

    if (profileMe) {
      let roles = profileMe.roles_coofis ? profileMe.roles_coofis : [];
      const idx = roles.findIndex(
        (x) => x.state === 'Aksi.Reaksi.Admin',
      );
      if (idx > -1) setIsCrud(true);
      else setIsCrud(false);
    }
  }, []);

  useEffect(() => {
    if (!dialogFilter) {
      setPage(0);
      onFilter();
    }
  }, [dialogFilter]);

  function groupBy(arr, prop) {
    return arr.reduce((grouped, obj) => {
      const key = obj[prop];
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(obj);
      return grouped;
    }, {});
  }

  useEffect(() => {
    if (optionsTitle) {
      let tmp = [];
      // year

      //
      tmp = groupBy(optionsTitle.results, 'year');
      let obb = Object.keys(tmp).map((x) => {
        return {
          name: x,
          isHead: true,
          children: tmp[x],
        };
      });

      setTitleOptions(obb);
      console.log(obb);
    }
  }, [optionsTitle]);

  useEffect(() => {
    setPage(0);
    onFilter();
  }, [title]);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setTimeout(() => {
      dispatch(onGetListAksiPerubahan( searchState,
        page,
        filter
          ? `&batch=[${filter.batch}]&year=[${
              filter.year
            }]&new_title=${JSON.stringify(filter.title)}`
          : '',));
    }, 1000);
  };

  const handleChangePage = (e, newpage) => {
    dispatch(
      onGetListAksiPerubahan(
        searchState,
        newpage,
        filter
          ? `&batch=[${filter.batch}]&year=[${
              filter.year
            }]&new_title=${JSON.stringify(filter.title)}`
          : '',
      ),
    );
    setPage(newpage);
  };
  const onDelete = (id) => {
    setDeletedId(id);
    setOpenDeleteDialog(true);
  };

  const column = [
    {
      headerName: 'NAMA',
      field: 'display_name',
      width: 600,
      headerClassName: 'table-header',
    },
    {
      headerName: 'RATING',
      field: 'rating',
      align:'center',
      width: 175,
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.rating ? (
             <Rating name="read-only" readOnly value={params.row.rating} />
          ) : (
          "-"
          )}
        </div>
      ),
    },
    {
      headerName: 'NIP',
      field: 'nip',
      width: 160,
      headerClassName: 'table-header',
    },
    {
      headerName: 'JENIS KATEGORI',
      field: 'title',
      width: 350,
      headerClassName: 'table-header',
    }, {
      headerName: 'ANGKATAN',
      field: 'angkatan',
      width: 75,
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.angkatan ? (
             convertToRoman(params.row.angkatan)
          ) : (
          "-"
          )}
        </div>
      ),
    },
    {
      headerName: 'TAHUN',
      field: 'year',
      width: 75,
      headerClassName: 'table-header',
    },
    {
      headerName: 'SATUAN KERJA',
      field: 'satker',
      width: 350,
      headerClassName: 'table-header',
    },
    {
      headerName: 'UNIT KERJA',
      field: 'unker',
      width: 800,
      headerClassName: 'table-header',
    },

    {
      headerName: 'TERIMPLEMENTASI',
      field: 'implementation',
      width: 150,
      align: 'center',
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.implementation ? (
            <Chip
              label='Ya'
              sx={{backgroundColor: '#28c76f1f', color: '#28c76f'}}
            />
          ) : (
          "-"
          )}
        </div>
      ),
    },
    {
      headerName: 'View',
      field: 'url',
      align: 'center',
      width: 50,
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.url ? (
            <Visibility
              onClick={() => window.open(params.row.url)}
            ></Visibility>
          ) : (
            ''
          )}
        </div>
      ),
    },
  ];

  const crudColumn = [
    {
      headerName: 'NAMA',
      field: 'display_name',
      width: 450,
      headerClassName: 'table-header',
    },
    {
      headerName: 'RATING',
      field: 'rating',
      align:'center',
      width: 175,
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.rating ? (
             <Rating name="read-only" readOnly value={params.row.rating} />
          ) : (
          "-"
          )}
        </div>
      ),
    },
    {
      headerName: 'NIP',
      field: 'nip',
      width: 160,
      headerClassName: 'table-header',
    },
    {
      headerName: 'JENIS KATEGORI',
      field: 'title',
      width: 350,
      headerClassName: 'table-header',
    },
    {
      headerName: 'ANGKATAN',
      field: 'angkatan',
      width: 100,
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.angkatan ? (
             convertToRoman(params.row.angkatan)
          ) : (
          "-"
          )}
        </div>
      ),
    },
    {
      headerName: 'TAHUN',
      field: 'year',
      width: 75,
      headerClassName: 'table-header',
    },
    {
      headerName: 'UNIT KERJA',
      field: 'unker',
      width: 650,
      headerClassName: 'table-header',
    },
    {
      headerName: 'SATUAN KERJA',
      field: 'satker',
      width: 350,
      headerClassName: 'table-header',
    },
 

    {
      headerName: 'TERIMPLEMENTASI',
      field: 'implementation',
      width: 150,
      align: 'center',
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.implementation ? (
            <Chip
              label='Ya'
              sx={{backgroundColor: '#28c76f1f', color: '#28c76f'}}
            />
          ) : (
          "-"
          )}
        </div>
      ),
    },
    {
      headerName: 'PERINGKAT',
      field: 'order',
      align: 'center',
      width: 100,
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.order === 0 ? (
            "-"
          ) : (
            params.row.order
          )}  
        </div>
      ),
      
    },
    {
      headerName: 'VIEW',
      field: 'url',
      align: 'center',
      width: 50,
      headerClassName: 'table-header',
      renderCell: (params) => (
        <div>
          {params.row.url ? (
            <Visibility
              onClick={(e) => {
                e.stopPropagation();
                window.open(params.row.url);
              }}
            ></Visibility>
          ) : (
            ''
          )}
        </div>
      ),
    },

    {
      field: 'actions',
      type: 'actions',
      headerName: 'AKSI',
      width: 200,
      cellClassName: 'actions',
      getActions: (params) => {
        return [
          <ButtonOutlined
            key={params.id}
            onClick={() => onEdit(params)}
            sx={{
              background: '#505050',
              color: 'white',
              minWidth: '30px',
              width: '30px',
              height: '27px',
            }}
          >
            <EditOutlined sx={{color: 'white'}} />
          </ButtonOutlined>,
          <ButtonOutlined
            key={params.id}
            onClick={() => onDelete(params.id)}
            sx={{
              background: '#EA5455',
              color: 'white',
              minWidth: '30px',
              width: '30px',
              height: '27px',
            }}
          >
            <DeleteOutline sx={{color: 'white'}} />
          </ButtonOutlined>,
        ];
      },
    },
  ];

  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setTitle(event.target.value);
  };

  const onFilter = () => {
    console.log(filter ? JSON.stringify(filter.title) : 'a');
    dispatch(
      onGetListAksiPerubahan(
        undefined,
        undefined,
        filter
          ? `&batch=[${filter.batch}]&year=[${
              filter.year
            }]&new_title=${JSON.stringify(filter.title)}`
          : '',
      ),
    );
  };

  const handleRowClick = (params) => {
    setDetailData(params.row);
    setRoleDialog('detail');
    setOpenDialog(true);
  };

  const handleAddDialog = (type) => {
    if (type === 'add') setRoleDialog('add');
    else setRoleDialog('add_category');
    setOpenDialog(true);
  };

  const handleDialogDelete = () => {
    dispatch(onDeleteAksiPerubahan(deletedId));
    setOpenDeleteDialog(false);
    setTimeout(() => {
      dispatch(onGetListAksiPerubahan());
    }, 1000);
  };

  const handleOnKeyUp = (inputVal) => {
    setPage(0);
    if (inputVal.key === 'Enter') {
      if (inputVal.target.value !== '') {
        dispatch(
          onGetListAksiPerubahan(
            inputVal.target.value,
            page,
            filter
              ? `&batch=[${filter.batch}]&year=[${
                  filter.year
                }]&new_title=${JSON.stringify(filter.title)}`
              : '',
          ),
        );
      }
      if (inputVal.target.value === '') {
        dispatch(
          onGetListAksiPerubahan(
            undefined,
            undefined,
            filter
              ? `&batch=[${filter.batch}]&year=[${
                  filter.year
                }]&new_title=${JSON.stringify(filter.title)}`
              : '',
          ),
        );
      }
    }
  };

  const handleSearchChange = useCallback((e) => {
    setSearchState(e.target.value);
  }, []);

  const onEdit = (params) => {
    setDetailData(params.row);
    setRoleDialog('edit');
    setOpenDialog(true);
  };
  const rows = [];
  const StyledDataGrid = styled(DataGrid)(() => {
    return {
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#800000',
        color: '#fff',
      },
      '& .css-ptiqhd-MuiSvgIcon-root': {
        color: '#fff',
      },
      '& .MuiDataGrid-columnSeparator': {
        visibility: 'hidden',
      },
      '& .MuiDataGrid-row': {
        cursor: 'pointer',
      },
      '& .free': {
        backgroundColor: alpha(green[500], 0.3),
      },
      '& .taken': {
        backgroundColor: alpha(red[500], 0.3),
      },
      '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
        width: '0.4em',
        height: '0.6em',
      },
      '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
      },
      '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
      '& .MuiDataGrid-cell:focus': {
        outline: 'none',
      },
    };
  });

  return (
    <>
      <Typography
        sx={{fontSize: '18px', marginLeft: '20px', marginBottom: '10px'}}
      >
        Daftar Aksi Perubahan
      </Typography>

      <AppCard>
        <Stack>
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
            marginBottom={'1rem'}
            sx={{
              '& label.Mui-focused': {
                color: COLORS.primary,
              },
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: grey[500],
                },
                '&.Mui-focused fieldset': {
                  borderColor: COLORS.primary,
                  color: COLORS.primary,
                },
              },
            }}
          >
            <Stack direction={'row'} alignItems={'center'} gap={'10px'}>
              {isCrud ? (
                <>
                  {' '}
                  <Button
                    variant='contained'
                    onClick={handleClick}
                    size='small'
                    style={{
                      width: '120px',
                      backgroundColor: '#800000',
                      height: '40px',
                    }}
                  >
                    <Add /> Tambah
                  </Button>
                  <Menu
                    anchorEl={anchorElAdd}
                    open={Boolean(anchorElAdd)}
                    onClose={handleClose}
                  >
                    <MenuItem onClick={() => handleAddDialog('add_category')}>
                      Tambah Kategori
                    </MenuItem>
                    <MenuItem onClick={() => handleAddDialog('add')}>
                      Tambah Aksi Perubahan
                    </MenuItem>
                  </Menu>
                </>
              ) : (
                ''
              )}
            </Stack>

            <Stack direction={'row'} alignItems={'center'}>
              <TablePagination
                component='div'
                count={dataAksiPerubahan ? dataAksiPerubahan.count : 0}
                rowsPerPage={10}
                page={page}
                onPageChange={handleChangePage}
                // onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={'Baris per halaman'}
                labelDisplayedRows={({from, to, count}) =>
                  ` ${from}-${to} dari ${count}`
                }
                rowsPerPageOptions={[]}
              />
              <Stack flexDirection={'row'} alignItems={'center'} gap={'10px'}>
                <MdFilterList onClick={() => setDialogFilter(true)} />

                <AppSearch
                  onChange={(e) => {
                    handleSearchChange(e);
                  }}
                  onKeyUp={(e) => {
                    handleOnKeyUp(e);
                  }}
                />
              </Stack>
            </Stack>
          </Stack>

          <StyledDataGrid
            sx={{minHeight: '600px'}}
            columns={isCrud ? crudColumn : column}
            onRowClick={handleRowClick}
            className={classes.root}
            hideFooterPagination={true}
            hideFooter={true}
            rows={dataAksiPerubahan ? dataAksiPerubahan.results : []}
          />
        </Stack>
      </AppCard>
      <DialogPerubahan
        open={openDialog}
        role={roleDialog}
        detailData={detailData}
        handleClose={() => handleCloseDialog()}
      />
      <DialogDelete
        open={openOpenDeleteDialog}
        onClickClose={() => setOpenDeleteDialog(false)}
        onClickDelete={() => handleDialogDelete()}
      />
      <DialogImport
        open={openOpenImportDialog}
        onClickClose={() => setOpenImportDialog(false)}
      />
      <DialogFilter
        open={dialogFilter}
        onClose={() => setDialogFilter(false)}
      />
      <AppInfoView />
    </>
  );
};
